/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

/* Import types */
import type { MuensterDeviceCategory } from '@/types/deviceSensor';

export const MUENSTER_UNKNOWN_DEVICE_CATEGORY: MuensterDeviceCategory = 'unknown';

export const MUENSTER_DEVICE_CATEGORY_BY_PREFIX: Record<string, MuensterDeviceCategory> = {
    S: 'S',
    L: 'L',
    P: 'P',
    G: 'G_g',
    g: 'G_g',
    F: 'F_f',
    f: 'F_f',
    W: 'W',
    R: 'R',
    T: 'T',
    t: 'T',
    mR: 'mR',
    pP: 'pP',
    pS: 'pS',
    pF: 'pF_pf',
    pf: 'pF_pf',
};

export const MUENSTER_DEVICE_CATEGORY_LABELS: Record<MuensterDeviceCategory, string> = {
    S: 'Strom Bezug',
    L: 'Strom (Rück-)Lieferung',
    P: 'PV-Erzeugung',
    G_g: 'Gas',
    F_f: 'Fernwärme',
    W: 'Wasser',
    R: 'Strom',
    T: 'Wärmepumpe',
    mR: 'Unbekannt',
    pP: 'PV-Erzeugung',
    pS: 'Netzbezug',
    pF_pf: 'Wärme',
    unknown: 'Unbekannt',
};
